<template>
    <textarea
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholder"
        class="form-control"
        :class="{[optional_class]: true}"
        :rows="row"
    ></textarea>
</template>

<script>
export default {
    name: 'FormTextarea',
    props: {
        modelValue: {
            type: String
        },
        row: {
            type: [String, Number],
            default: 5
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ""
        },
        optional_class: {
            type: String,
            default: ''
        },
    },
    emits: [
        'update:modelValue'
    ],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
